import React, { createContext, useState, useContext, useCallback } from 'react';

const ToastContext = createContext();

// BIGLI-24：所有提醒（success / info / warning / error 四種型別皆同）跳出後，
// 各自停留 TOAST_DURATION_MS（5 秒）就自動消失；使用者也可在 5 秒內按 X 提前關掉。
// 計時器不放在這裡，而是掛在單一 <Toast> 元件上（見 components/common/Toast.js），
// 這樣每則才是從「自己出現的時間點」起算，連續跳多則不會互相延長或連帶關掉。
//
// showToast 刻意「不收」停留時間參數：RENT-34 時期曾留下 duration 參數卻在內部一律
// 忽略，呼叫端看起來設定得了、實際上完全沒作用，是最容易誤導人的假介面。
// PM 要求全站一致 5 秒，因此這裡直接不開放覆寫——要調整就改 constants/toast.js。

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  // 自動關閉與手動按 X 走的是同一條移除路徑，不存在第二套刪除邏輯。
  const removeToast = useCallback((id) => {
    setToasts(currentToasts => currentToasts.filter(toast => toast.id !== id));
  }, []);

  const clearAllToasts = useCallback(() => {
    setToasts([]);
  }, []);

  const showToast = useCallback((message, type = 'success') => {
    const id = Math.random().toString(36).substring(2, 9);
    setToasts(currentToasts => [...currentToasts, { id, message, type }]);
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, showToast, removeToast, clearAllToasts }}>
      {children}
    </ToastContext.Provider>
  );
};

// 創建一個簡易的 Hook 來使用 Toast Context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
